import React, { useState } from 'react';
import styles from './instruction.module.scss';
import { demoDayBulb, demoDayPitch, demoDayRocket, demoDayRocketCircle, slotIcon, test } from 'src/assets/images';
import { Button, ConfirmModal } from 'src/components/common';
import { useAppSelector } from 'src/store/hooks';
import { useNavigate } from 'react-router-dom';

const steps = [
    {
        icon: <img src={demoDayBulb} alt='step-icons' />,
        step: 'Step 1',
        title: 'Post Your Idea  on Venture Verse',
        description: (
            <>
                List your idea to get noticed, <span className={styles.highlight}>gain traction</span>, and be part of India’s boldest startup community.
            </>
        )
    },
    {
        icon: <img src={demoDayPitch} alt='step-icons' />,
        step: 'Step 2',
        title: 'Register & Submit Pitch Deck',
        description: (
            <>
                Secure your seat. Upload your pitch deck and <span className={styles.highlight}>tell us your story</span> — clearly, confidently, and with conviction.
            </>
        )
    },
    {
        icon: <img src={slotIcon} alt='step-icons' />,
        step: 'Step 3',
        title: 'Book Your Slot for Round 1 PItch',
        description: (
            <>
                Pick a time. Present your idea to our screening panel. We’ll <span className={styles.highlight}>shortlist top ideas</span> for the final showdown.
            </>
        )
    },
    {
        icon: <img src={demoDayRocketCircle} alt='step-icons' />,
        step: 'Step 4',
        title: 'Final Investor Pitch Round',
        description: (
            <>
                Pitch to real investors. Get  <span className={styles.highlight}>feedback, funding,</span> or maybe your first <span className={styles.highlight}> big YES.</span>
            </>
        )
    }
];

export default function Instruction() {
    const navigate = useNavigate()
    const { demoDay, myVenture, loading, globalDemoDay } = useAppSelector(
        (store) => store.venture
    );
    const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);

    // state 
    const [show, setShow] = useState<boolean>(false);
    const buttonArray = ['', 'Submit Your Deck & Get Noticed', 'Book Your Slot for Round 1', 'You are In! View Your Slot']
    const button: number = demoDay?.demoDayProgress === 'Register' ? 1 : demoDay?.demoDayProgress === 'Pitch Deck' ? 2 : demoDay?.demoDayProgress === 'Done' ? 3 : 0
    const buttonText = buttonArray[button];
    const isDemoDayRunning = !!globalDemoDay?.[0]?.id;
    function handleNavigate() {
        navigate(`/login?prev=${encodeURIComponent('/demo-day')}`)
    }
    function handleRegister() {
        if (button === 0 && !isDemoDayRunning) {
            return
        }
        if (!isAuthorized) {
            return setShow(true)
        }
        const path = !myVenture?.id ? `/post-venture?prev=${encodeURIComponent('/demo-day-register/payment')}` : myVenture?.draft ? `/post-venture?id=${myVenture?.id}&type=draft&prev=${encodeURIComponent('/demo-day-register/payment')}` : button === 0 ? `/demo-day-register/payment?id=${myVenture?.id}` : button === 1 ? `/demo-day-register/document-submission?id=${myVenture?.id}` : button === 2 ? `/demo-day-register/slot-booking?id=${myVenture?.id}` : `/demo-day-detail?id=${myVenture?.id}`
        navigate(path)
    }
    return (
        <>
            <ConfirmModal
                title=""
                description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
                    <span>To register for Demo Day </span>
                    <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
                </p>}
                openConfirmModal={show}
                onClose={() => setShow(false)}
                onSubmit={handleNavigate}
                submitText="Sign in"
                type="confirm"
            />
            <section className={styles.participate}>
                <h2>How To Participate ?</h2>
                <div className={styles.steps}>
                    {steps.map((item, index) => (
                        <div key={index} className={styles.stepBox}>
                            <div className={styles.icon}>{item.icon}</div>
                            <div className={styles.stepNumber}>{item.step}</div>
                            <div className={styles.title}>{item.title}</div>
                            <p>{item.description}</p>
                        </div>
                    ))}
                </div>
                <div className={styles.register}>
                    {button !== 0 && <Button variant='primary' size='small' style={{ width: 'auto', height: '50px' }} disabled={loading} onClick={handleRegister}>
                        <img src={demoDayRocket} className={styles.rocket} alt="register now" />
                        {buttonText}
                    </Button>}
                    {button === 0 && (
                        <Button
                            variant="primary"
                            size="small"
                            style={{
                                width: 'auto',
                                height: '50px',
                                ...(button === 0 && !isDemoDayRunning ? { cursor: 'auto' } : {})
                            }}
                            disabled={loading}
                            onClick={handleRegister}
                        >
                            <img src={demoDayRocket} className={styles.rocket} alt="register now" />
                            {isDemoDayRunning ? (
                                <>
                                    Register Now for <del>₹499</del> ₹249
                                </>
                            ) : (
                                'Registrations closed'
                            )}
                        </Button>
                    )}
                </div>
            </section>
        </>
    );
}
